// 약관·정책 문안 (앱 내부 렌더 — 숏폼 정책 전문은 대외 비공개라 외부 URL 을 두지 않는다)
// 원본: docs/ops/policy/shortform-policy.html (초안 v1.0 · 법무 검토 전)
// ⚠️ 문안을 고치면 canonicalPolicyText 해시가 바뀐다 — 반드시 policy.version 을 올리고
//    docs/ops/policy/ 소스, 안내 팝업 문안과 함께 고칠 것 (docs/ops/policy/README.md).

export const SHORTFORM_POLICY_KEY = "shortform_revenue";

export const SHORTFORM_POLICY = {
  key: SHORTFORM_POLICY_KEY,
  version: "v1.0",
  title: "숏폼 수익 배분 정책",
  subtitle: "네이버 클립 · 카카오톡 숏폼 채널 수익 배분 기준",
  effectiveFrom: "2026-10-01",
  graceUntil: "2026-09-30",
  isDraft: false, // 2026-09-23 대표 「원문 확정」 — 초안 표시 해제(해시 원문에는 들어가지 않는 값)
  summary: [
    "수익 배분은 작품의 출처에 따라 세 갈래입니다 — ① 클립 전용 작품 40:60, ② 레이블리 제공 작품(작품별 쉐어), ③ 직접 구한 작품.",
    "이번에 바뀌는 것은 ③ 하나입니다. 2026년 10월 1일 발생분부터 레이블리 40 : 크리에이터 60이 적용됩니다.",
    "레이블리의 지원으로 숏폼 수익창출 자격을 얻은 채널에만 적용됩니다. 유튜브에는 적용되지 않습니다.",
    "미션·챌린지·어워즈 등 콘텐츠 성과와 무관한 활동 보상은 전액 크리에이터 몫입니다.",
  ],
  preamble: [
    "네이버 클립과 카카오톡 숏폼의 수익창출 채널은 세 주체의 협력으로 열렸습니다. 크리에이터는 기획·편집과 꾸준한 게시로 조회수와 구독자를 쌓았고, 작품 권리사는 수익이 나기 전부터 작품을 내어주었으며, 회사는 권리사·플랫폼과의 협약 체결, 작품 제공, 적법 사용에 대한 공증, 채널 운영 지원으로 채널이 수익을 낼 수 있는 상태를 만들었습니다.",
    "이 정책은 그 협력 위에서 발생하는 수익의 배분 기준을 정합니다. 배분은 콘텐츠에 사용된 작품의 출처에 따라 정해지며, 이번에 조정되는 것은 그중 한 갈래(직접 구한 작품)뿐입니다.",
    "회사가 수익의 일부를 계속 배분받는 것은, 수익이 나기 전부터 작품과 협약·공증을 대어 수익을 낼 수 있는 상태를 만든 데 따른 것입니다. 채널이 잘 될수록 회사도 함께 이익을 보는 구조이므로, 회사에는 작품 제공·플랫폼 협의·운영 지원을 계속할 이유가 생깁니다. 한 번 받고 끝나는 구조였다면 회사가 채널에 계속 관여할 이유가 없습니다.",
  ],
  articles: [
    {
      no: "제1조",
      title: "목적",
      items: [
        '이 정책은 주식회사 루나르트(이하 "회사")가 지원하는 네이버 클립 및 카카오톡 숏폼 채널에서 발생하는 수익의 배분 기준과, 그 산정·정산에 관한 사항을 정함을 목적으로 합니다.',
      ],
    },
    {
      no: "제2조",
      title: "정의",
      items: [
        '"클립 전용 작품"이란 회사가 숏폼 게시용으로 제공하는 전용 작품을 말합니다.',
        '"회사 제공 작품"이란 일반 협업으로 제공되는 권리사 작품을 말합니다.',
        '"그 외 작품"이란 크리에이터가 직접 구했거나 제1호·제2호에 해당하지 않는 작품을 말합니다.',
        '"수익창출 자격"이란 해당 플랫폼에서 콘텐츠 수익을 배분받을 수 있는 채널 자격을 말합니다.',
        '"공문"이란 크리에이터가 회사 제공 작품을 적법하게 사용 중임을 보증하기 위하여 회사가 플랫폼에 제출한 문서를 말합니다.',
      ],
    },
    {
      no: "제3조",
      title: "적용 대상",
      items: [
        "이 정책은 회사의 지원으로 숏폼 수익창출 자격을 얻은 채널에 적용합니다. 회사의 지원 없이 자격을 취득한 채널에는 적용하지 아니합니다.",
        "적용 플랫폼은 네이버 클립과 카카오톡 숏폼으로 하며, 양 플랫폼에 동일하게 적용합니다. 유튜브 등 그 밖의 플랫폼에는 적용하지 아니합니다.",
        "제1항의 해당 여부는 회사가 판정하여 크리에이터에게 통지합니다.",
      ],
    },
    {
      no: "제4조",
      title: "수익 배분",
      items: [
        "그 외 작품을 사용한 콘텐츠의 수익은 회사 40, 크리에이터 60의 비율로 배분합니다. 회사의 몫은 회사가 채널의 수익창출 자격 형성에 기여한 데 대한 것입니다.",
        "클립 전용 작품을 사용한 콘텐츠의 수익은 종전과 같이 회사 40, 크리에이터 60의 비율로 배분하며, 회사 제공 작품을 사용한 콘텐츠의 수익은 작품별로 안내한 배분율을 따릅니다. 사전 안내가 없었던 작품은 회사 60, 크리에이터 40으로 합니다.",
        "이 정책에 동의하지 아니한 크리에이터의 그 외 작품 수익은 종전과 같이 전액 크리에이터에게 귀속합니다.",
        "미션·챌린지·어워즈 등 콘텐츠 성과와 무관한 활동 보상은 전액 크리에이터에게 귀속하며, 제5조의 수익 산정에서 제외합니다.",
      ],
    },
    {
      no: "제5조",
      title: "수익 산정",
      items: [
        "콘텐츠별 수익은 다음 세 단계로 산정합니다. 가. 콘텐츠의 정산월 조회수를 구하고, 나. 채널의 조회수당 단가(해당 월 채널 수익 ÷ 채널의 정산월 조회수 합계)를 구한 뒤, 다. 콘텐츠별 수익 = 정산월 조회수 × 조회수당 단가로 계산합니다.",
        "정산월 조회수는 당월 누적 조회수에서 직전월 누적 조회수를 뺀 값으로 하며, 음수가 되는 경우 0으로 처리합니다.",
        "제2항에 따라 어느 달의 정산월 조회수가 0으로 처리된 경우, 다음 달의 차감 기준은 낮아진 누적치로 잡히므로 해당 구간의 조회수는 다음 정산에 함께 계산됩니다. 이 처리로 크리에이터에게 불리한 차이가 발생하지 않습니다.",
        "조회수당 단가는 채널 단위로 산정하며 채널 내 모든 콘텐츠에 공통으로 적용합니다. 채널의 정산월 조회수 합계가 0인 경우 해당 월의 배분은 없습니다.",
        "미션·챌린지·어워즈 등 콘텐츠 성과와 무관한 활동 보상은 산정 대상 수익에서 제외합니다.",
        "크리에이터의 판단과 회사의 집계가 다른 경우, 크리에이터가 해당 플랫폼에서 확인한 데이터를 상세히 제공하는 것을 전제로 회사에 검토를 요청할 수 있습니다.",
      ],
      example: {
        title: "계산 예시 — 검산에 필요한 값은 정산 내역서에 함께 표기됩니다",
        rows: [
          ["해당 월 채널 수익", "1,000,000원"],
          ["채널의 정산월 조회수 합계", "2,000,000회"],
          ["조회수당 단가 (1,000,000 ÷ 2,000,000)", "0.5원/회"],
          ["내 콘텐츠의 정산월 조회수", "300,000회"],
          ["콘텐츠 수익 (300,000 × 0.5)", "150,000원"],
          ["그 외 작품인 경우 — 회사 40% / 크리에이터 60%", "60,000원 / 90,000원"],
        ],
      },
    },
    {
      no: "제6조",
      title: "정산 및 지급",
      items: [
        "배분된 수익의 정산 주기, 지급 방법 및 절차는 회사의 기존 정산 절차를 따릅니다.",
        "정산 내역서에는 제5조의 산정에 사용된 값(채널 수익, 정산월 조회수, 조회수당 단가, 적용 배분율)을 표기합니다.",
      ],
    },
    {
      no: "제7조",
      title: "동의 및 유예",
      items: [
        "이 정책은 크리에이터의 동의를 받아 적용합니다. 회사는 서비스 내 안내를 통하여 정책의 내용을 고지하고 동의를 수집합니다.",
        "유예기간(2026년 9월 30일까지) 동안 크리에이터는 동의를 미룰 수 있습니다. 유예기간이 지난 후에는 동의 또는 거절 중에서 선택합니다.",
        "유예기간 동안 발생한 수익은 종전 조건으로 정산합니다.",
        "동의·거절의 기록(일시, 방법, 동의한 문안의 버전)은 보관되며, 크리에이터는 서비스 내에서 자신의 기록과 동의 시점의 문안을 언제든지 확인할 수 있습니다.",
        "이 정책이 개정되는 경우 회사는 개정 내용을 종전 문안과 대비하여 고지하고 새 버전에 대한 동의를 다시 요청합니다.",
        "동의한 크리에이터는 2026년 9월 30일까지 동의를 철회할 수 있습니다. 철회한 경우 제9조 제3항의 거절과 동일하게 처리하며, 2026년 10월 1일 이후에는 철회할 수 없습니다.",
      ],
    },
    {
      no: "제8조",
      title: "계약과의 관계",
      items: [
        "이 정책은 크리에이터와 회사 사이의 협업 계약 및 부속합의서와 함께 적용되며, 수익 배분에 관하여 양자의 내용이 다른 경우 개별 계약이 우선합니다.",
        "이 정책의 효력은 네이버 클립·카카오톡 숏폼에 한정되며, 유튜브 등 다른 플랫폼에서의 협업 조건에는 영향을 미치지 아니합니다.",
        "협업 계약의 종료는 기존 게시물의 삭제 사유가 되지 아니합니다. 게시물 삭제 의무는 제9조 제3항 다목의 경우에만 발생합니다.",
      ],
    },
    {
      no: "제9조",
      title: "동의 거절 시 처리",
      items: [
        "크리에이터는 이 정책에 대한 동의를 거절할 수 있습니다.",
        "거절의 의사표시는 서비스 내 안내 화면에서 하며, 회사는 거절이 확정되기 전에 제3항의 처리 내용을 고지하고 확인을 받습니다.",
        "거절이 확정된 경우 다음 각 목과 같이 처리합니다. 가. 회사 제공 작품(클립 전용 작품을 포함한다)의 사용을 중단합니다. 나. 회사가 플랫폼에 제출한 공문을 회수하며, 그 효력이 중단됩니다. 다. 회사 제공 작품으로 제작한 게시물을 회사가 통지한 기한 내에 삭제하여야 합니다. 라. 본 항의 효력은 네이버 클립·카카오톡 숏폼에 한정되며, 유튜브 협업은 그대로 유지되고 협업 계약의 해지 사유가 되지 아니합니다. 마. 크리에이터가 다시 동의하는 경우 회사 제공 작품의 제공을 재개합니다.",
        "거절한 크리에이터의 그 외 작품 수익 배분은 제4조 제3항에 따릅니다.",
      ],
    },
  ],
  addendum: [
    "이 정책은 2026년 10월 1일 이후 발생한 수익부터 적용합니다.",
    "유예기간은 2026년 9월 30일까지로 합니다.",
    "2026년 9월 30일까지 발생한 수익은 종전 조건에 따라 정산합니다.",
    "시행일 이후 회사의 지원을 받아 협업을 시작하거나 채널을 개설하는 경우, 이 정책이 적용됩니다.",
    "최초 시행분에 관하여, 제9조 제3항 다목의 게시물 삭제 기한은 2026년 9월 30일로 합니다.",
  ],
};

// 문안 해시(document_hash)의 원문 — 결정적(deterministic)이어야 한다.
// 렌더링 마크업이 아니라 조문 텍스트만 이어 붙이므로, 스타일 변경은 해시에
// 영향을 주지 않고 문안 변경만 해시를 바꾼다.
export function canonicalPolicyText(doc = SHORTFORM_POLICY) {
  const parts = [doc.key, doc.version, doc.title];
  parts.push(...doc.preamble);
  doc.articles.forEach((a) => {
    parts.push(`${a.no} (${a.title})`);
    a.items.forEach((item, i) => parts.push(`${i + 1}. ${item}`));
  });
  parts.push("부칙");
  doc.addendum.forEach((item, i) => parts.push(`${i + 1}. ${item}`));
  return parts.join("\n");
}

// /policies 목록 메타 — 이용약관·개인정보 처리방침은 공개 라우트의 기존 전문을 쓴다
export const POLICY_CATALOG = {
  shortform_revenue: {
    icon: "shortform",
    detailPath: "/policies/shortform-revenue",
    platforms: "네이버 클립 · 카카오톡 숏폼",
  },
  terms: { icon: "doc", externalPath: "/terms-of-service" },
  privacy: { icon: "lock", externalPath: "/privacy-policy" },
  // 마케팅 수신 문안은 앱 안에서 바로 보여 준다(inlineText) — Policies 행 클릭 · 알림 채널 시트 「문안 보기」 가 같은 모달(MarketingPolicyModal)을 연다
  marketing: { icon: "bell", inlineText: true },
};

// ----------------------------------------------------------------------------
// 마케팅 정보 수신(선택) 문안 — 2026-09-08 「채널 등록형」 알림 채널 등록 안내(PR-C)와 /policies 가 같은 문안을 쓴다.
// 🔒 법적 틀(고정): 선택 동의 · 기본 OFF · 사전 체크 금지 · 「동의하지 않아도 서비스 알림은 그대로」 문장을 빼지 말 것.
//    정산·검수·문의 답변 알림은 계약 이행 통지(약관 제15조)라 동의와 무관하게 나간다.
// ⚠️ 문안을 고치면 canonicalMarketingText 해시(document_hash)가 바뀐다 — policy 표 'marketing' 행의 version 을 함께 올린다.
// ----------------------------------------------------------------------------
export const MARKETING_POLICY_KEY = "marketing";
export const MARKETING_POLICY_VERSION = "v1.0";
export const MARKETING_POLICY_TITLE = "마케팅 정보 수신 안내";

export const MARKETING_POLICY_TEXT = [
  "목적: 신규 작품 오픈, 이벤트, 크리에이터 혜택 안내",
  "항목: 이메일, 휴대폰 번호",
  "채널: 앱 알림, 이메일, 카카오톡, 문자",
  "빈도: 월 2~3회 이내",
  "보유 기간: 동의를 철회할 때까지",
  "철회 방법: 설정 › 약관 및 정책 › 마케팅 정보 수신 끄기 (언제든 가능)",
  "동의하지 않아도 정산·검수·문의 답변 등 서비스 알림은 그대로 받을 수 있습니다.",
];

// document_hash 원문 — 결정적. 줄 순서·문장이 그대로 해시에 들어간다(canonicalPolicyText 와 같은 원칙).
export function canonicalMarketingText() {
  return [MARKETING_POLICY_KEY, MARKETING_POLICY_VERSION, MARKETING_POLICY_TITLE, ...MARKETING_POLICY_TEXT].join("\n");
}
